import { type MCPServerInfo } from '../../types';

const MiroServer: MCPServerInfo = {
  serverId: 'MIRO',
  name: 'Miro',
  slug: 'miro',
  description: 'Miro MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'mcp/miro:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: '@llmindset/mcp-miro'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['miroOAuthKey'],
    properties: {
      miroOAuthKey: {
        type: 'string',
        description: 'Miro OAuth Key',
        sensitive: true
      }
    }
  },
  deprecated: true
};

export default MiroServer;
